<template>
    <div class="examine">
        <Box :title="ProcessName=='预处理审核'?ProcessName:'维修审核'">
            <FacilityDetails :data="ProcessModel" />
            <div class="infoBox" v-if="!ProcessName=='预处理审核'">
                <p class="title">配件信息</p>
                <div class="accessoriesItems" v-for="item in RepairPartsList">
                    <p>{{item.SBMC}}</p>
                    <div>
                        <span>规格：{{item.GGXH}}</span>
                        <span>单位：{{item.DW}}</span>
                        <span>数量：{{parseInt(item.SYSL)}}</span>
                        <span>¥ {{Number(item.JE).toFixed(2)}}</span>
                    </div>
                </div>
            </div>
            <div class="infoBox">
                <p class="title">维修费用</p>
                <div class="maintainItems">
                    <span>配件费用</span>
                    <span>¥ {{PartsFee}}</span>
                </div>
                <div class="maintainItems">
                    <span>维修费用</span>
                    <span>¥ {{RepairFee}}</span>
                </div>
                <div class="maintainItems">
                    <span>维修总费用</span>
                    <span>¥ {{RepairFee+PartsFee}}</span>
                </div>
            </div>
            <div class="infoBox flowBox">
                <p class="title">审批流程</p>
                <StepModule :StepList="AuiitorList" />
            </div>
            <div class="infoBox ideaBox">
                <p class="title">审批意见</p>
                <textarea type="text" placeholder="请输入" cols="3" v-model="Remark" />
                </div>
        </Box>
        <div class="ButtomContent">
        </div>

        <Footer v-if="this.$route.params.ExistsButton"
            @reject="reject"
            @resolve="resolve"
            :button="[{text:'拒绝',color:'#858585',background:'#DEDEDE',event:'reject'},{text:'同意',color:'#fff',background:'#4FA69E',event:'resolve'}]"
        />
    </div>
</template>

<script>
    import Box from '../../components/commonBox/commonBox'
    import Title from '../../components/commonTitle/commonTitle'
    import FacilityDetails from '../../components/facilityDetails/facilityDetails'
    import Footer from '../../components/footer/footer'
    import StepModule from '../../components/stepModule/stepModule'
    export default {
        name: 'Examine',
        data() {
            return {
                ProcessModel:{},//维修进程基本信息
                RepairPartsList:[],//维修配件集合
                AuiitorList:[],//维修进程
                Remark: null,
                RepairFee:0,//维修费用
                PartsFee:0,// 配件费用
                JCHH:null,//进程行号
                JCBH:null,//进程编号
                ProcessName:null,//审批进程名称（只有在预处理审核时展示）
            }
        },
        mounted() {
            this.$scrollscreen('.commonBox','start');
            this.loadAxios();
        },
        components: {
            Box,
            Title,
            FacilityDetails,
            Footer,
            StepModule
        },
        methods: {
            resolve() {//同意
                this.$post('api/Audit/RepairAudit',{
                    EquCode:this.ProcessModel.EquNo,
                    UserCode:this.$UserInfo.UserId,
                    AuditAdvice:this.Remark,
                    IsAdopt:'1',//是否通过
                    ProcessNumber:this.JCHH,//进程行号
                    ProcessNo:this.JCBH,//进程编号
                    ApplyOrder:this.$route.params.item.OrderNo,//维修单号
                    Token:'123456'
                }).then(result=>{
                    this.$Toast(result.Msg);
                    if(result.Status){
                        setTimeout(x=>{
                            this.$Bus.$emit('Message',this.$route.params.item.OrderNo);
                            this.$router.go(-1);
                        },1500);
                    }
                })
            },
            reject(){//否决
                this.$post('api/Audit/RepairAudit',{
                    UserCode:this.$UserInfo.UserId,
                    AuditAdvice:this.Remark,
                    IsAdopt:'2',//是否通过
                    ProcessNumber:this.JCHH,//进程行号
                    ProcessNo:this.JCBH,//进程编号
                    ApplyOrder:this.$route.params.item.OrderNo,//维修单号
                    Token:'123456'
                }).then(result=>{
                    this.$Toast(result.Msg);
                    if(result.Status){
                        setTimeout(x=>{
                            this.$Bus.$emit('Message',this.$route.params.item.OrderNo);
                            this.$router.go(-1);
                        },1500);
                    }
                })
            },loadDataDefault(){//获取维修信息
              return  this.$get('/api/Repair/GetRepairInfo',{
                    RepairNo:this.$route.params.item.OrderNo,
                    Store:this.$UserInfo.StoreCode,
                    Token:'1235'
                })
            },maintainOther(){//获取维修配件和维修费用
               return this.$get('api/Repair/MaintenanceOther',{
                    WXDH:this.$route.params.item.OrderNo,
                    JCHH:'1'
                })
            },loadExamineDefault(){//获取维修审批进程
               return this.$get('api/Audit/AuditorList',{
                    RepairNo:this.$route.params.item.OrderNo,//维修单号
                    UserCode:this.$UserInfo.UserId,
                    Token:'1243'
                })
            },loadAudit(){//获取审批信息
                return this.$get('api/Audit/GetRepairProcessList',{
                    RepairCode:this.$route.params.item.OrderNo,
                    EquCode:this.$route.params.item.EquId,
                    Token:'12345'
                });
            },
            loadAxios(){
                this.$axios.all([this.loadDataDefault(),this.maintainOther(),this.loadExamineDefault(),this.loadAudit()]).then(result=>{
                     this.ProcessModel=result[0].RepairInfo;
                    if(!result[0].RepairInfo.RepairNo)
                    {
                      this.$Toast('数据异常或维修信息缺失!');
                      return false;
                    }

                    result[1].accessories.map(x=>{
                        this.RepairPartsList.push(x);
                    });
                    this.AuiitorList=result[2].AuiitorList;
                    if(result[3].RepairProcessModel.length!==0){
                        this.JCHH=result[3].RepairProcessModel[0].ProcessNumber;
                        this.JCBH=result[3].RepairProcessModel[0].ProcessCode;
                        this.RepairFee=result[3].RepairProcessModel[0].RepairFee;
                        this.PartsFee=result[3].RepairProcessModel[0].PartsFee;
                        this.ProcessName=result[3].RepairProcessModel[0].ProcessName;
                    }
                }).catch(err=>{
                    this.$Toast('系统异常,请联系管理员!');
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .accessoriesItems{
        margin-bottom: 20px;
        p{
            color: $TEXT-DARK-COLOR;
            font-size: 28px;
            margin-bottom: 14px;
        }
        div{
            color: #858585;
            font-size: 28px;
            display: flex;
            span{
                margin-right: 35px;
                &:last-child{
                    margin-right: 0;
                    font-size: 32px;
                    color: $TEXT-DARK-COLOR;
                    flex:1;
                    text-align: right;
                    font-weight: bold;
                }
            }
        }
    }
    .maintainItems{
        display: flex;
        align-items: center;
        margin-bottom: 32px;
        span{
            &:first-child{
                font-size: 28px;
                color: #999;
                flex: 1;
            }
            &:last-child{
                font-size: 32px;
                color: $TEXT-DARK-COLOR;
                font-weight: bold;
            }
        }
        &:last-child{
            margin-bottom: 0;
        }
    }
    .flowBox{
        .title{
            margin-bottom: 50px;
        }
    }
    .ideaBox{
        textarea{
            font-size: 30px;
            width: 100%;
            border: none;
            resize: none;
            &::-webkit-input-placeholder{
                color: #858585;
            }
        }
    }
    .ButtomContent{
        margin-top: 100px;
    }
</style>



// WEBPACK FOOTER //
// src/page/examine/examine.vue